import { render, staticRenderFns } from "./FieldTextReply.vue?vue&type=template&id=06898d56&scoped=true"
import script from "./FieldTextReply.vue?vue&type=script&lang=js"
export * from "./FieldTextReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06898d56",
  null
  
)

export default component.exports